module.exports = {"validation":{"required":"Αυτή η τιμή είναι υποχρεωτική","email":"Μη έγκυρη διεύθυνση email"}}